import React, { useState } from 'react';
import { api } from '@/lib/api';

export default function AdminLogin({ onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const r = await api.post('/admin/login', { username, password });
      localStorage.setItem('seicon_admin_token', r.data.token);
      onSuccess?.();
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-canvas flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-md bg-bg-elevated border border-border-line rounded-lg p-8 shadow-[0_4px_24px_rgba(14,14,16,0.06)]" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-9 h-9 rounded-sm bg-brand-orange flex items-center justify-center">
            <span className="font-display font-bold text-white text-[14px] leading-none">SIII</span>
          </div>
          <div>
            <div className="font-display font-bold uppercase text-ink-primary text-[16px] tracking-tightish">SEICON III Admin</div>
            <div className="font-body text-[11px] uppercase text-ink-soft tracking-wider3">Content Management</div>
          </div>
        </div>

        <label className="block font-body text-[12px] font-semibold uppercase text-ink-muted tracking-wider2">Username</label>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="mt-1 w-full border border-border-line rounded-sm px-3 py-2.5 font-body text-[14px] bg-white focus:outline-none focus:border-ink-primary"
          data-testid="login-username"
          autoComplete="username"
        />

        <label className="mt-4 block font-body text-[12px] font-semibold uppercase text-ink-muted tracking-wider2">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full border border-border-line rounded-sm px-3 py-2.5 font-body text-[14px] bg-white focus:outline-none focus:border-ink-primary"
          data-testid="login-password"
          autoComplete="current-password"
        />

        {err && <div className="mt-3 font-body text-[12px] text-brand-red">{err}</div>}

        <button disabled={loading} className="btn-primary w-full mt-6" data-testid="login-submit">
          {loading ? 'Signing in…' : 'Sign In'}
        </button>

        <p className="mt-6 font-body text-[11px] text-ink-soft">Authorized personnel only.</p>
      </form>
    </div>
  );
}
